export default "__VITE_ASSET__UhZPewt9__"